import * as ACTION from 'constant/action'
import path from 'path'
import { v4 as uuidv4 } from 'uuid'

const getFile = (fileMeta, name) => (fileMeta ? (fileMeta.file || new File([fileMeta], `${name}.html`, { type: 'text/html' })) : false)

export default (fileMeta, name, title) => {
  if (fileMeta?.file !== ACTION.REMOVED) {
    const file = getFile(fileMeta, name)
    const meta = fileMeta
    ? {
      content_type: file.type,
      file_extension: path.extname(file.name),
      file_name: title || uuidv4(),
      file_size: file.size
    }
    : false

    return {
      file,
      meta
    }
  } else {
    return { meta: ACTION.REMOVED }
  }
}
